import React, { useEffect, useState } from 'react';
import { Modal, Alert, Loading, initials } from '../../ui';
import { api } from '../../ui/api';

// Choose an active vendor for an audit or booking. `onPick` performs the assignment.
const VendorPicker = ({ open, title, currentVendorId, onClose, onPick }) => {
  const [vendors, setVendors] = useState(null);
  const [selected, setSelected] = useState(null);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    setSelected(null);
    setError('');
    api('/vendor/all_active_vendors').then(setVendors).catch((e) => { setError(e.message); setVendors([]); });
  }, [open]);

  const confirm = async () => {
    if (!selected) return;
    setSaving(true);
    setError('');
    try {
      await onPick(selected);
      onClose();
    } catch (e) {
      setError(e.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      open={open}
      title={title}
      subtitle="Only active vendors are listed."
      onClose={onClose}
      footer={(
        <>
          <button type="button" className="btn btn-secondary" onClick={onClose}>Cancel</button>
          <button type="button" className="btn btn-primary" disabled={!selected || saving} onClick={confirm}>
            {saving ? 'Assigning…' : 'Assign vendor'}
          </button>
        </>
      )}
    >
      <Alert>{error}</Alert>
      {!vendors ? <Loading /> : (
        <div className="vendor-pick">
          {vendors.map((v) => {
            const isCurrent = v.id === currentVendorId;
            return (
              <button
                type="button"
                key={v.id}
                disabled={isCurrent}
                className={`vendor-option${selected && selected.id === v.id ? ' on' : ''}`}
                onClick={() => setSelected(v)}
                style={isCurrent ? { opacity: 0.55, cursor: 'not-allowed' } : undefined}
              >
                <div className="avatar">{initials(v.company_name)}</div>
                <div className="grow">
                  <div className="strong">{v.company_name}</div>
                  <div className="small muted">{v.representative_name} · {v.company_phone}</div>
                </div>
                {isCurrent && <span className="small muted">Current</span>}
              </button>
            );
          })}
          {!vendors.length && <p className="muted">No active vendors. Activate one under Vendors first.</p>}
        </div>
      )}
    </Modal>
  );
};

export default VendorPicker;
